import { determineColor } from '../../util/color'
import { percentage } from '../../util/formatters'
import { money } from '../../util/formatters'
import { AcosCellProps } from './AcosCell'

/**
 * Version format comparison:
 * | Parameter          | v1 Format                | v2 Format             |
 * |--------------------|--------------------------|-----------------------|
 * | acos               | percentage (43% → 43.0)  | decimal (43% → 0.43)  |
 * | target_acos        | basis points (22% → 2200)| decimal (22% → 0.22)  |
 * | default_target_acos| basis points (22% → 2200)| decimal (22% → 0.22)  |
 */
export const calculate = ({
    acos: acosInput,
    target_acos,
    default_target_acos,
    cost,
    marketplace,
    version = 1,
}: AcosCellProps) => {
    let target = target_acos || default_target_acos
    let acos = acosInput

    if (version === 1) {
        target = basisPointsToPercentage(target)
        acos = percentageToDecimal(acos)
    } else if (version === 2) {
        target = decimalToBasisPoints(target)
    } else {
        throw new Error(`Invalid version: ${version}`)
    }

    const color = determineColor(acos * 100, target, cost)
    const sales = cost / acos
    const m = marketplace ?? null

    return {
        spend: money(cost, m) ?? '',
        sales: money(sales, m) ?? '',
        acos: percentage(acos * 100) ?? '',
        color,
    }
}

export const percentageToDecimal = (percentage: number) => {
    return percentage / 100
}

export const basisPointsToPercentage = (basisPoints: number) => {
    return basisPoints / 100
}

export const decimalToBasisPoints = (decimal: number) => {
    return decimal * 100
}
